/**
 * Split a quantity into the units a `numberOfProducts` allowance covers (which
 * keep the discount) and the rest (charged full price). `cap` undefined = no
 * limit, so every unit is covered.
 */
export function splitAllowanceUnits(
  quantity: number,
  cap: number | undefined
): { discountedQuantity: number; fullQuantity: number } {
  const discountedQuantity =
    cap === undefined ? quantity : Math.min(cap, quantity);

  return { discountedQuantity, fullQuantity: quantity - discountedQuantity };
}
